/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authloginnoaccount3Inputs */



/**
* | output |
* | --- |
* | "Need an account?" |
*
* @param {Authloginnoaccount3Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authloginnoaccount3 = /** @type {((inputs?: Authloginnoaccount3Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authloginnoaccount3Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Need an account?")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Besoin d'un compte ?")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Benötigen Sie ein Konto?")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("需要帳戶嗎？")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("계정이 없으신가요?")
	return /** @type {LocalizedString} */ ("アカウントをお持ちでないですか？")
});
export { authloginnoaccount3 as "authLoginNoAccount" }